import React from 'react';
import { Icon, Text } from '@chakra-ui/react';

import { CenteredContainer } from 'app/components/Core';
import { ReactComponent as InfoSvg } from 'resources/images/info.svg';
import { EXPIRED_SHARE_LINK_MESSAGE } from 'app/components/Shares/Share404/constants';

export const Share404 = () => {
  return (
    <CenteredContainer
      width={670}
      padding="8px"
      textAlign="center"
      display="flex"
      flexDirection="column"
    >
      <Icon as={InfoSvg} width="96px" height="96px" color="P.50" />
      <Text color="M.70" fontWeight={500} fontSize="lg" pt={6}>
        No link found
      </Text>
      <Text
        color="M.60"
        fontWeight={400}
        fontSize="md"
        data-testid="primary-message"
      >
        {EXPIRED_SHARE_LINK_MESSAGE}
      </Text>
    </CenteredContainer>
  );
};
